function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from "react";
import { Animated, View } from "react-native";
import { useBiblo } from "../hooks/Biblo.hook";
import { IndexHeader } from "../components/index/IndexHeader.component";
import { IndexSectionHeader } from "../components/index/IndexSectionHeader.component";
import { IndexItem } from "../components/index/IndexItem.component";
import { getViewStyles } from "../helpers/getStyles.helper";
export const IndexScreen = () => {
  const {
    files,
    searchValue,
    enabledTags,
    indexOptions,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || indexOptions.disableDefaultStyles;
  const filteredFiles = useMemo(() => {
    const lowerCaseQuery = searchValue.toLowerCase();
    return lowerCaseQuery || enabledTags.length ? [...files].map(section => ({
      ...section,
      data: section.data.filter(exports => {
        let skip = false;
        if (enabledTags.length) {
          skip = !enabledTags.some(tag => {
            var _exports$tags;
            return (_exports$tags = exports.tags) === null || _exports$tags === void 0 ? void 0 : _exports$tags.includes(tag);
          });
        }
        if (lowerCaseQuery) {
          var _exports$subtitle, _exports$searchTerms;
          skip = skip || !(exports.title.toLowerCase().includes(lowerCaseQuery) || (_exports$subtitle = exports.subtitle) !== null && _exports$subtitle !== void 0 && _exports$subtitle.toLowerCase().includes(lowerCaseQuery) || (_exports$searchTerms = exports.searchTerms) !== null && _exports$searchTerms !== void 0 && _exports$searchTerms.some(term => term.includes(lowerCaseQuery)));
        }
        return !skip;
      })
    })) : files;
  }, [files, searchValue, enabledTags]);
  const Wrapper = indexOptions.wrapperComponent || View;
  const SectionFooter = indexOptions.sectionFooterComponent || View;
  const Footer = indexOptions.footerComponent || View;
  return /*#__PURE__*/React.createElement(Wrapper, {
    headerTitle: indexOptions.headerTitle,
    style: getViewStyles(indexOptions.wrapperStyle, {
      flex: 1
    }, disableDefaultStyles)
  }, /*#__PURE__*/React.createElement(Animated.SectionList, _extends({
    sections: filteredFiles,
    keyExtractor: (_, index) => `item-${index}`,
    stickySectionHeadersEnabled: true,
    ListHeaderComponent: IndexHeader,
    ListFooterComponent: () => /*#__PURE__*/React.createElement(Footer, {
      style: indexOptions.footerStyle
    }),
    renderSectionHeader: _ref => {
      let {
        section
      } = _ref;
      return /*#__PURE__*/React.createElement(IndexSectionHeader, {
        title: section.title,
        itemsCount: section.data.length
      });
    },
    renderSectionFooter: _ref2 => {
      let {
        section
      } = _ref2;
      return section.data.length ? /*#__PURE__*/React.createElement(SectionFooter, {
        title: section.title,
        itemsCount: section.data.length,
        style: [{
          height: indexOptions.sectionListItemHeight || 40
        }, indexOptions.sectionFooterStyle]
      }) : null;
    },
    renderItem: _ref3 => {
      let {
        item
      } = _ref3;
      return /*#__PURE__*/React.createElement(IndexItem, {
        file: item
      });
    },
    getItemLayout: (data, index) => ({
      length: indexOptions.sectionListItemHeight || 40,
      offset: (indexOptions.sectionListItemHeight || 40) * index,
      index
    })
  }, indexOptions.sectionListProps)));
};
//# sourceMappingURL=Index.screen.js.map